module.exports = __webpack_public_path__ + "static/media/yt-dropshipping.1ebd70d4.jpeg";